import { render, staticRenderFns } from "./RecurringOrderCompanySelector.vue?vue&type=template&id=22f326de&"
import script from "./RecurringOrderCompanySelector.vue?vue&type=script&lang=ts&"
export * from "./RecurringOrderCompanySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports